// @flow
import * as React from 'react';

import { withRouter } from 'app/context/Router';
import BoxBody from 'components/BoxBody';
import DialogContent from 'components/DialogContent';
import BirthdateSelector from 'chat/components/BirthdateSelector';
import UserActions from 'user/UserActions';
import User from 'entities/User';
import Button from 'components/Button';

import './styles/JoinInfoPageBirthdate.scss';

type Props = {
  onDone: User => void,
  onError: any => void,
  router: *,
};

type State = {
  birthdate: ?Date,
  errors: *,
};

class JoinInfoPageBirthdate extends React.Component<Props, State> {
  state = {
    birthdate: null,
    errors: null,
  };

  onBirthdateChange = (birthdate: ?Date) => {
    this.setState({ birthdate });
  };

  canSubmit = () => {
    return !!this.state.birthdate;
  };

  submit = () => {
    const onError = response => {
      this.props.onError(response);

      const errors = {};

      if (response && response.code === 'validation_error') {
        for (const field of response['field_errors']) {
          errors[field['field_name']] = field.messages.join(', ');
        }
      }

      // $FlowFixMe
      this.setState({ errors });
    };

    UserActions.update({ birthdate: this.state.birthdate }).then(user => {
      // onDone gets passed into this component via JoinInfoPage
      // but not via setup routes, so we need to manually reroute
      // the user to progress to the next step
      if (this.props.onDone) {
        this.props.onDone(user);
      } else {
        this.props.router.push('/');
      }
    }, onError);
  };
  render() {
    return (
      <DialogContent
        size="small"
        full
        className="JoinInfoPageBirthdate"
        title={'What is your birthday?'}
        subtext={'No one else will see this information.'}>
        <BoxBody divided>
          <BirthdateSelector initialDate={this.state.birthdate} onChange={this.onBirthdateChange} />

          {this.state.errors && 'birthdate' in this.state.errors ? (
            <span className="JoinInfoPageBirthdate-Error">{this.state.errors['birthdate']}</span>
          ) : null}

          <Button disabled={!this.canSubmit()} onClick={this.submit}>
            Save
          </Button>
        </BoxBody>
      </DialogContent>
    );
  }
}

export { JoinInfoPageBirthdate };

export default withRouter(JoinInfoPageBirthdate);
